import config from "../../../config/config"

export const signupConfig = {
  name: "signup",
  //used in the reducers
  uppercaseName: "SIGNUP",
  // useful to map objects in collection
  modelProps: [],
  // can be empty (might be usefull if you need paging...)
  collectionProps: [],
  // path to your rest server
  paths: {
    item: config.signup,
    collection: '/'
  },
  headers: {
    "content-type": "application/json",
    "X-Auth-Token": ""
  },
  defaultModel: {
    "username": "",
    "password": "",
    "passwordConfirm": "",
    "email": ""
  },
  fetchOnce: false
}

export default signupConfig